export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_PAN = "USER_PAN";
export const USER_LOGIN_REFRESH_FAILED = "USER_LOGIN_REFRESH_FAILED";
export const USER_LOGIN_REFRESH_SUCCESS = "USER_LOGIN_REFRESH_SUCCESS";
export const USER_LOGIN_REFRESH = "USER_LOGIN_REFRESH";
export const POSTER_OPEN = "POSTER_OPEN";
export const ENACH_UMR = "ENACH_UMR";
export const ENACH_FOLIO = "ENACH_FOLIO";
export const ENACH_BANK_ACC = "ENACH_BANK_ACC";
export const ENACH_END_DATE = "ENACH_END_DATE";
export const ENACH_START_DATE = "ENACH_START_DATE";
export const ENACH_MAX_AMOUNT = "ENACH_MAX_AMOUNT";
